import './WaterSensors.scss'
import { useEffect, useState } from 'react'
import AddWaterSensorPopup from '../AddWaterSensorPopup/AddWaterSensorPopup'
import { fetchWaterSensor } from '../../APICalls/GetRequests'
import Cookies from 'js-cookie'

const WaterSensors = () => {
    const [showPopup, setShowPopup] = useState(false)
    const [waterSensors, setWaterSensors] = useState([])

    useEffect(() => {
        fetchWaterSensor(Cookies.get('session_key'))
            .then(data => {
                console.log(data)
                setWaterSensors(data)
            })
            .catch(error => {
                console.log(error)
            })
    }, [])

    const handleOpenPopup = () => setShowPopup(true)
    const closeWaterSensorPopup = () => setShowPopup(false)

    return (
        <div className='WaterSensors'>
            <h1>Water Sensors</h1>

            <div className="water-sensors__table-container">
                <table className="water-sensors__table">
                    <thead>
                        <tr>
                            <th>Field</th>
                            <th>Sensor ID</th>
                            <th>Water Present</th>
                            <th>Sensitivity</th>
                            <th>Charging</th>
                            <th>Temperature</th>
                            <th>Zone</th>
                        </tr>
                    </thead>

                    <tbody>
                        {waterSensors.map(sensor => (
                            <tr key={sensor.id}>
                                <td>{sensor.field_name || sensor.field_id}</td>
                                <td>{sensor.serial}</td>
                                <td>{sensor.water ? 'Yes' : 'No'}</td>
                                <td>{sensor.sensPct}%</td>
                                <td>{sensor.charging ? 'Charging' : 'Not Charging'}</td>
                                <td>{sensor.temp}°</td>
                                <td>{sensor.zone_name || '—'}</td>
                            </tr>
                        ))}

                        {waterSensors.length === 0 && (
                            <tr>
                                <td colSpan="7" style={{ textAlign: 'center' }}>
                                    No water sensors found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {showPopup && <AddWaterSensorPopup onClose={closeWaterSensorPopup} />}
        </div>
    )
}

export default WaterSensors


